/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'

import { mpfRListsHttp } from '../../../../assets/ts/api/mpf-r-lists-http'
import { addOrUpdateQuickLink } from '../../../../assets/ts/data/quick-links'
import { convertRTE } from '../../../../assets/ts/formatting/formatting'
import { scrollToTop } from '../../../../assets/ts/general/general'
import {
  addToPIIAuditTrail,
  getPIIScanInfo,
  handlePIIValidationFailure,
  loadPII,
} from '../../../../assets/ts/pii/pii'
import { isValidURL } from '../../../../assets/ts/validations/validations'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import PageOverlayBusy from '../../../../components/page-overlay/page-overlay-busy'
import PIIPopup from '../../../../components/page-overlay/pii-popup'
import { MetadataContextInterface } from '../../../../store/metadata-context-provider'
import {
  ALL_SELECT_LABEL,
  ALL_SELECT_OPTION,
  ALL_SELECT_OPTION_STRING,
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
} from '../../../../utils/constants/global-constants'
import { NO_CHANGE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import CustomSelect from '../../../../utils/controls/custom-select'
import InputText from '../../../../utils/controls/input-text'
import { IsArchived, optionsTypes } from '../../../../utils/controls/select-options-data'

interface Props {
  assignedComponentOptions: any
  cancel: () => void
  clickedIndex?: number
  closePopup?: (e) => void
  components: any
  editQuickLink?: any
  fetchQuickLinks: () => void
  initialMajcomOptions?: any
  initialSectionOptions?: any
  majcoms: any
  roleContext?: any
  sections: any[]
  showAddPopup: boolean
  showEdit?: any
  toggleView: () => void
  visibleSquadrons?: any
}
const AddEditView = ({
  assignedComponentOptions,
  cancel,
  clickedIndex,
  closePopup,
  components,
  editQuickLink,
  fetchQuickLinks,
  initialMajcomOptions,
  initialSectionOptions,
  majcoms,
  roleContext,
  sections,
  showAddPopup,
  showEdit,
  toggleView,
  visibleSquadrons
}: Props) => {
  if (showAddPopup) {
    scrollToTop()
  }
  const componentOptions = [
    ALL_SELECT_OPTION,
    ...components.map((c) => ({
      label: c.Component,
      value: c.ComponentCode,
    })),
  ]

  const [majcomOptions, setMajcomOptions] = useState<optionsTypes[]>([ALL_SELECT_OPTION])
  const [sectionOptions, setSectionOptions] = useState<Array<optionsTypes>>([ALL_SELECT_OPTION])
  const [squadronOptions, setSquadronOptions] = useState<Array<optionsTypes>>(
    [ALL_SELECT_OPTION_STRING]
  )

  const [inputValues, setInputValues] = useState({
    AssignedComponent: editQuickLink?.['AssignedComponent/MetadataValue']
      ? editQuickLink?.['AssignedComponent/MetadataValue']
      : ALL_SELECT_LABEL,
    AssignedComponentCode: editQuickLink?.AssignedComponentCode
      ? editQuickLink.AssignedComponentCode
      : ALL_SELECT_VALUE,
    IsArchived: editQuickLink?.IsArchived ? editQuickLink.IsArchived : false,
    SectionCodeOptions: [],
    SectionCodes: editQuickLink?.SectionCodes?.length > 0 ?
    editQuickLink.SectionCodes : [],
    ServicingMAJCOM: editQuickLink?.['ServicingMAJCOM/MetadataValue']
      ? editQuickLink?.['ServicingMAJCOM/MetadataValue']
      : ALL_SELECT_LABEL,
    ServicingMAJCOMCode: editQuickLink?.ServicingMAJCOMCode
      ? editQuickLink.ServicingMAJCOMCode
      : ALL_SELECT_VALUE,
    Squadron: editQuickLink?.Squadron
    ? editQuickLink.Squadron
    : ALL_SELECT_VALUE_STRING,
    Title: editQuickLink?.Title ? editQuickLink?.Title : ALL_SELECT_VALUE_STRING,
    Url: editQuickLink?.Url ? editQuickLink?.Url : ALL_SELECT_VALUE_STRING,
  })

  const [quickLinkValidations, setQuickLinkValidations] = useState({
    AssignedComponent: false,
    QuickLink: false,
    QuickLinkMsg: '',
    Section: false,
    ServicingMAJCOM: false,
    Title: false,
    TitleMsg: '',
    Url: false,
    UrlMsg: '',
  })
  const [displayValidation, setDisplayValidation] = useState({
    showPII: false,
  })
  const [piiScan, setPIIScan] = useState({})

  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [showPageOverlay, setShowPageOverlay] = useState<boolean>(false)
  const titleRef: any = useRef<any>(null)
  const descriptionRef = useRef<any>(null)
  const generateCode = (code: number) => {
    return code > 0 ? code : null
  }
  const generateMajcomOptions = (
    eValue: string | undefined,
    assignComponents: MetadataContextInterface['components'],
    majcoms: MetadataContextInterface['majcoms']
  ): optionsTypes[] => {
    const defaultOption = ALL_SELECT_OPTION
    if (!eValue) return [defaultOption]
    const componentCode =
      eValue === 'All' ? -1 : assignComponents.find((item) => item.Label === eValue)?.ComponentCode
    if (!componentCode) return [defaultOption]
    const filteredMajcoms = majcoms.filter(
      (item) => componentCode === -1 || item.ParentComponentCode === componentCode
    )
    const mappedOptions = filteredMajcoms.map(({ Label, Value }) => ({
      label: Label,
      value: Value,
    }))
    if (mappedOptions.length > 1) {
      mappedOptions.unshift(defaultOption)
    }
    return mappedOptions
  }
  const onClickAlert = () => {
    setShowAlert(false)
  }

  const handleChange = (key: string, value: boolean | number | string) => {
    setInputValues((prev) => ({
      ...prev,
      [key]: value,
    }))
  }
  const changeAssignedComponent = (e: { label: string; value: number }) => {
    const majOptions: any[] = initialMajcomOptions
      .filter(
        (item) => item.assignedComponentCode === e.value || e.value === -1
      )
      .map((majcom) => ({
        assignedComponentCode: majcom.assignedComponentCode,
        label: majcom.label,
        squadron: majcom.squadron,
        value: majcom.value,
      }))

    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((e) => e.section === formattedSection &&
                majOptions.some((maj) => e.squadron.includes(maj.squadron)))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isLeadership ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

  const squadOptions = []
  majOptions.filter((majcom) => majcom.squadron).map((majcom) => {
    majcom.squadron?.map((item) => {
      squadOptions.push({
        label: item,
        value: item
      })
    })
  })

    if (majOptions.length > 1 && majOptions[0].value !== -1) {
      majOptions.unshift(ALL_SELECT_OPTION)
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    }

    setMajcomOptions(majOptions)
    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)

    handleChange('AssignedComponent', e.label)
    handleChange('AssignedComponentCode', e.value)
    handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
    handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
    handleChange('ServicingMAJCOM', majOptions.length === 1 ? majOptions[0].label : ALL_SELECT_LABEL)
    handleChange('ServicingMAJCOMCode', majOptions.length === 1 ? majOptions[0].value : ALL_SELECT_VALUE)
    handleChange('Squadron', squadOptions.length === 1 ? squadOptions[0].value ?? '' : ALL_SELECT_VALUE_STRING)

  }

  const changeMajcom = (e: { label: string; value: number }) => {
    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((sect) => sect.section === formattedSection &&
                (e.squadron.includes(sect.squadron) || e.value === -1))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isLeadership ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    let squadOptions: any = []

    if (e?.squadron) {
      e.squadron?.map((item) => {
        squadOptions.push({
          label: item,
          value: item
        })
      })
    } else {
      squadOptions = []
      majcomOptions.map((majcom) => {
          majcom?.squadron?.map((item) => {
            squadOptions.push({
              label: item,
              value: item
            })
          })
        })
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    }

    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)

    handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
    handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
    handleChange('Squadron', squadOptions.length === 1 ? squadOptions[0].value ?? '' : ALL_SELECT_VALUE_STRING)
    handleChange('ServicingMAJCOMCode', e.value)
    handleChange('ServicingMAJCOM', e.label)
    handleChange('ServicingMAJCOMCode', e.value)
  }

  const generateString = (options: any) => {
    return JSON.stringify(options.map((options) => options.label))
  }

  const changeSection = (e: { label: string; value: number }) => {
    handleChange('SectionCodes', sectionOptions.length === 1 ? [sectionOptions[0].value] : [...e.map((section) => section.value)])
    handleChange('SectionCodeOptions', sectionOptions.length === 1 ? [sectionOptions[0]] : e)
  }

  const changeSquadron = (e: any) => {
    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false
      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')
          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((sect) => sect.section === formattedSection &&
                (sect.squadron === e.value || e.value === -1))) {
              containsSquadron = true
            }
          }
        }
      })
      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isLeadership ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]
      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    setSectionOptions(sectOptions)
    handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
    handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
    handleChange('Squadron', e.value)
  }

  const handleIsArchived = (e) => {
    setInputValues((prev) => ({
      ...prev,
      IsArchived: e.value,
    }))
  }
  useEffect(() => {
    const titleElemnt = document.getElementById('Name')
    if (titleRef?.current && titleElemnt) {
      if (clickedIndex === 0) {
        descriptionRef?.current?.scrollIntoView({ behavour: 'auto', block: 'end' })
        titleElemnt.focus()
      } else if (clickedIndex === 1) {
        descriptionRef?.current?.scrollIntoView({ behavour: 'auto', block: 'nearest' })
        titleElemnt.focus()
      } else {
        titleRef?.current?.scrollIntoView(true)
        titleElemnt.focus()
      }
    }
  }, [titleRef, showEdit])

  useEffect(() => {
    const majOptions: any[] = initialMajcomOptions
      .filter(
        (item) => item.assignedComponentCode === inputValues.AssignedComponentCode ||
          inputValues.AssignedComponentCode === -1
      )
      .map((majcom) => ({
        assignedComponentCode: majcom.assignedComponentCode,
        label: majcom.label,
        squadron: majcom.squadron,
        value: majcom.value,
      }))

    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((e) => e.section === formattedSection &&
                majOptions.some((maj) => e.squadron.includes(maj.squadron)))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isLeadership ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    const squadOptions: any = []
    majOptions.map((majcom) => {
      majcom?.squadron?.map((item) => {
        squadOptions.push({
          label: item,
          value: item
        })
      })
    })

    if (majOptions.length > 1 && majOptions[0].value !== -1) {
      majOptions.unshift(ALL_SELECT_OPTION)
    }
  
    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    }

    setMajcomOptions(majOptions)
    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)


    handleChange('AssignedComponent', assignedComponentOptions.length === 1 ? assignedComponentOptions[0].label ?? '' : ALL_SELECT_LABEL)
    handleChange('AssignedComponentCode', assignedComponentOptions.length === 1 ? assignedComponentOptions[0].value ?? '' : ALL_SELECT_VALUE)
    handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
    handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
    handleChange('ServicingMAJCOM', majOptions.length === 1 ? majOptions[0].label ?? '' : ALL_SELECT_LABEL)
    handleChange('ServicingMAJCOMCode', majOptions.length === 1 ? majOptions[0].value ?? '' : ALL_SELECT_VALUE)
    handleChange('Squadron', squadOptions.length === 1 ? squadOptions[0].value ?? '' : ALL_SELECT_VALUE_STRING)

  }, [
    assignedComponentOptions,
    initialMajcomOptions,
    initialSectionOptions,
    editQuickLink
  ])

  useEffect(() => {
    if (editQuickLink) {
      setInputValues((prev) => ({
        ...prev,
        AssignedComponent: editQuickLink?.AssignedComponent,
        AssignedComponentCode: editQuickLink?.AssignedComponentCode,
        SectionCodeOptions: editQuickLink?.SectionCodes?.map((sectionCode, index) => ({
          label: editQuickLink?.Section[index],
          value: sectionCode
        })),
        SectionCodes: editQuickLink?.SectionCodes?.length > 0 ?
        editQuickLink.SectionCodes : [],
        ServicingMAJCOMCode: editQuickLink?.ServicingMAJCOMCode,
        Squadron: editQuickLink?.Squadron,
      }))
    }
  }, [editQuickLink])

  const saveQuickLink = async (piiIsValid) => {
    setShowPageOverlay(true)
    const userdetails = mpfRListsHttp().me()
    const userId = (await userdetails).userId
    const currentDate = new Date()

    const addObj = {
      AssignedComponentCode: generateCode(inputValues.AssignedComponentCode),
      IsArchived: inputValues.IsArchived,
      ItemCreated: currentDate,
      ItemCreatedBy: userId,
      ItemModified: currentDate,
      ItemModifiedBy: userId,
      Section: generateString(
        inputValues.SectionCodeOptions
      ),
      SectionCodes: JSON.stringify(
        inputValues.SectionCodes
      ),      ServicingMAJCOMCode: generateCode(inputValues.ServicingMAJCOMCode),
      Squadron: inputValues.Squadron,
      Title: inputValues.Title,
      Url: inputValues.Url,
      eKey: editQuickLink ? editQuickLink.eKey : '',
      eTag: editQuickLink ? editQuickLink.eTag : '',
    }
    try {
      if (piiIsValid) {
        await addOrUpdateQuickLink(addObj)
        addToPIIAuditTrail('Settings-QuickLink', addObj.eKey, piiScan, userId)
      }
      await fetchQuickLinks()
      cancel()
      setShowPageOverlay(false)
    } catch (error) {
      console.error(error)
      cancel()
      setShowPageOverlay(false)
    }
  }
  const handleSubmit = async () => {
    let isValid = true
    const validations = {
      AssignedComponent: false,
      QuickLink: false,
      QuickLinkMsg: '',
      Section: false,
      ServicingMAJCOM: false,
      Title: false,
      TitleMsg: '',
      Url: false,
      UrlMsg: '',
    }

    if (inputValues.Title === '') {
      isValid = false
      validations.Title = true
      validations.TitleMsg = 'Please enter a name'
    }
    if (!isValidURL(inputValues.Url)) {
      isValid = false
      validations.Url = true
      validations.UrlMsg = 'Please enter a valid Url'
    }

    if (
      (editQuickLink?.AssignedComponentCode === null &&
        inputValues.AssignedComponentCode === -1 ||
        editQuickLink?.AssignedComponentCode === inputValues.AssignedComponentCode) &&
      editQuickLink?.IsArchived === inputValues.IsArchived &&
      (editQuickLink?.ServicingMAJCOMCode === null && inputValues.ServicingMAJCOMCode === -1 ||
        editQuickLink?.ServicingMAJCOMCode === inputValues.ServicingMAJCOMCode) &&
      editQuickLink?.Title === inputValues.Title &&
      editQuickLink?.Url === inputValues.Url &&
      editQuickLink?.SectionCodes.sort().join(',') === inputValues?.SectionCodes.sort().join(',')) {
      isValid = false
      setShowAlert(true)
    }

    setQuickLinkValidations(validations)
    if (isValid) {
      const piiIsValid = await validateAndHandlePIISubmission('submitted')
      await saveQuickLink(piiIsValid)
      setInputValues({
        AssignedComponentCode: ALL_SELECT_VALUE,
        IsArchived: null,
        Section: ALL_SELECT_LABEL,
        SectionCode: ALL_SELECT_VALUE,
        ServicingMAJCOMCode: ALL_SELECT_VALUE,
        Title: '',
        Url: '',
      })
      toggleView()
    }
  }

  /**validateAndHandlePIISubmission
   * Validates the PII (Personally Identifiable Information) for submission and handles the submission process.
   *
   * @param {string} action - The action being performed (e.g., 'submitted').
   * @param {string} position - The position to displayValidation PII compliance validation messages ('top' or 'bottom').
   * @returns {boolean} - Indicates whether the submission can proceed.
   */
  const validateAndHandlePIISubmission = async (action = 'submitted') => {
    let canSubmit = true
    const piiScanData = {
      Name: inputValues.Title,
      URL: inputValues.Url,
    }
    try {
      const uploadData = await getPIIScanInfo(piiScanData, piiScan)
      if (action === 'submitted') {
        setPIIScan({ ...uploadData.piiScanResult })
      }
      if (uploadData.canSubmit) {
        canSubmit = true
      } else {
        handlePIIValidationFailure(null, setDisplayValidation)
        canSubmit = false
      }
    } catch (error) {
      console.error('PII validation failed:', error)
      canSubmit = false
    }
    return canSubmit
  }
  useEffect(() => {
    setDisplayValidation((prev) => ({
      ...prev,
      showPII: false,
    }))
    if (Object.keys(piiScan).length > 0) {
      Object.keys(piiScan).forEach((key) => {
        if (key === 'FileArray') {
          for (const file of piiScan[key].value) {
            if (file?.resultsArray?.length > 0 && !file?.userAnswer) {
              setDisplayValidation((prev) => ({
                ...prev,
                showPII: true,
              }))
            }
          }
        } else {
          if (piiScan[key]?.resultsArray?.length > 0 && !piiScan[key]?.userAnswer) {
            setDisplayValidation((prev) => ({
              ...prev,
              showPII: true,
            }))
          }
        }
      })
    }
  }, [piiScan])

  useEffect(() => {
    loadPII()
  }, [])

  return (
    <div
      className={
        showAddPopup
          ? 'border-radius whitebg bordered15 mt-2'
          : 'settingseditpopup w-100 position-relative border-top1 mt-2'
      }
      id='scroll'
    >
      {showAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={NO_CHANGE_MESSAGE}
          onClick={onClickAlert}
          yes='OK'
        />
      )}
      {showPageOverlay && <PageOverlayBusy />}
      {showAddPopup && (
        <div className='p-3 border-bottom4 '>
          <h4
            aria-label='Add Quick Links'
            className='m-0 p-0 d-inline-block font-15 poppins-semibold color-primary text-uppercase'
            tabIndex={0}
          >
            Add Quick Links
          </h4>
        </div>
      )}
      {displayValidation.showPII && <PIIPopup piiScan={piiScan} setPIIScan={setPIIScan} />}
      <div className='px-2 py-1'>
        <div className='row'>
          <div className={showAddPopup ? 'col-sm-12 col-md-12 mb-2' : ''} ref={titleRef}>
            <InputText
              changeHandler={(e: any) => handleChange('Title', e.target.value)}
              errorMessage={quickLinkValidations.Title}
              formClassName='d-flex flex-column'
              info='Name '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: 'Name',
                name: 'Name',
                placeholder: 'Enter Name',
                value: inputValues.Title,
              }}
              isInfo
              isMandatory
              label='Name'
              msg={quickLinkValidations.TitleMsg}
              value={inputValues.Title}
            />
          </div>
          <div className={showAddPopup ? 'col-sm-12 col-md-12 mb-2' : ''} ref={descriptionRef}>
            <InputText
              changeHandler={(e: any) => handleChange('Url', e.target.value)}
              errorMessage={quickLinkValidations.Url}
              formClassName='d-flex flex-column'
              info='URL'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' url ',
                name: 'URL',
                placeholder: 'https://example.com',
                value: inputValues.Url,
              }}
              isInfo
              isMandatory
              label='URL'
              msg={quickLinkValidations.UrlMsg}
              value={inputValues.Url}
            />
            <span className='font-11 title-color35 poppins-medium'>
              <span className='color-primary'>Hint: </span>(http://example.com or
              https://example.com)
            </span>
          </div>

          <div className={showAddPopup ? 'col-sm-12 col-lg-4 mb-2' : 'col-sm-12 col-lg-4 mb-2'}>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              error={quickLinkValidations.AssignedComponent}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='Assigned Component'
              info='Assigned Component '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              label='Assigned Component'
              menuPlacement='bottom'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Assigned Component'
              onChange={changeAssignedComponent}
              options={assignedComponentOptions}
              value={inputValues?.AssignedComponentCode}
            />
          </div>

          <div className={showAddPopup ? 'col-sm-12 col-lg-4 mb-2' : 'col-sm-12 col-lg-4 mb-2'}>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              disabled={roleContext.isCPOwner || 
                roleContext.isAssignedComponentOwner}
              error={quickLinkValidations.ServicingMAJCOM}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='ServicingMAJCOM'
              info='Servicing MAJCOM'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              label='Servicing MAJCOM'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Servicing MAJCOM'
              onChange={changeMajcom}
              options={majcomOptions}
              value={inputValues.ServicingMAJCOMCode}
            />
          </div>
          <div className={showAddPopup ? 'col-sm-12 col-lg-4 mb-2' : 'col-sm-12 col-lg-4 mb-2'}>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              disabled={roleContext.isCPOwner || 
                roleContext.isAssignedComponentOwner || 
                roleContext.isMAJCOMOwner}
              error={quickLinkValidations.ServicingMAJCOM}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='ServicingOrganization'
              info='Servicing Organization'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              label='Servicing Organization'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Servicing Organization'
              onChange={changeSquadron}
              options={squadronOptions}
              value={inputValues.Squadron}
            />
          </div>
          <div className={showAddPopup ? 'col-sm-12 col-md-4 mb-2' : 'col-sm-12 col-lg-4 mb-2'}>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              error={quickLinkValidations.Section}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='Section'
              info='Section '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              isMulti
              label='Section'
              menuPosition='fixed'
              name='Section'
              onChange={changeSection}
              options={sectionOptions}
              value={inputValues.SectionCodeOptions}
            />
          </div>
          {!showAddPopup && (
            <div className='col-sm-12 col-lg-4 mb-2'>
              <CustomSelect
                className='form-lg w-100 sourcesanspro font-13 customselect'
                formClassName='form-vertical text-nowrap poppins-semibold font-11'
                id='IsArchived'
                info='IsArchived'
                infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'mb-1 font-12 poppins-medium title-color',
                }}
                isInfo
                label='Is Archived'
                menuPortalTarget={document.body}
                menuPosition={'fixed'}
                name='Is Archived'
                onChange={handleIsArchived}
                options={IsArchived}
                value={inputValues.IsArchived}
              />
            </div>
          )}
        </div>
        <div className='d-flex py-1 flex-wrap'>
          <div className='ms-auto settingsbtns d-flex'>
            {showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-save font-11 pe-1'
                  label='Save'
                  onClick={handleSubmit}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    closePopup(!showAddPopup)
                  }}
                  type='button'
                />{' '}
              </>
            )}
            {!showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-update font-11 pe-1'
                  label='Update'
                  onClick={handleSubmit}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    cancel()
                  }}
                  type='button'
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default AddEditView
